import { useEffect, useState } from "react";
import Lenis from "lenis";
import api from "@/lib/api";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import Marquee from "@/components/site/Marquee";
import BusinessTypes from "@/components/site/BusinessTypes";
import Projects from "@/components/site/Projects";
import HowWeWork from "@/components/site/HowWeWork";
import WhyAbout from "@/components/site/WhyAbout";
import QuoteForm from "@/components/site/QuoteForm";
import Footer from "@/components/site/Footer";
import { trackPageview } from "@/lib/analytics";

export default function Landing() {
  const [content, setContent] = useState(null);
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    trackPageview();
    api.get("/content").then((r) => setContent(r.data)).catch(() => {});
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); window.__lenis = null; };
  }, []);

  if (!content) {
    return (
      <div className="min-h-screen bg-navy flex items-center justify-center">
        <img src="/logos/icon.png" alt="Loading" className="w-14 animate-pulse" />
      </div>
    );
  }

  return (
    <div className="App bg-white">
      <Nav />
      <Hero hero={content.hero} />
      <Services services={content.services} />
      <Marquee text={content.banner_text} />
      <BusinessTypes types={content.business_types} />
      <Projects projects={content.projects} />
      <HowWeWork data={content.how_we_work} />
      <WhyAbout about={content.about} why={content.why} />
      <QuoteForm services={content.services} closingCta={content.closing_cta} />
      <Footer settings={settings} />
    </div>
  );
}
